import React from 'react';
import autoBind from 'react-autobind';
import { Redirect } from 'react-router-dom';
import ChipInput from 'material-ui-chip-input';
import isEmail from 'validator/lib/isEmail';
import Chip from 'material-ui/Chip';
import { Record } from 'immutable';
import { InvitationRecord } from '../../../feathers/records';
import feathers from '../../../feathers';
import EditPermissionsToggles from '../../../components/PermissionsToggles/EditPermissions';
import EntityPermissionsToggles from '../../../components/PermissionsToggles/EntityPermissions';
import FacilityPermissionsToggles from '../../../components/PermissionsToggles/FacilityPermissions';
import { Panel } from '../../../components/Panel';
import noty from '../../../lib/noty';
import './style.scss';

// Split an array into two arrays with equal(ish) length
// TODO: this could be used to put the markerTypeCategories
// in alpha order down their columns...but it will be a PIA
// const splitArray = (array) => {
//   const middle = Math.ceil(array.length / 2)
//   return [
//     array.slice(0, middle),
//     array.slice(middle, array.length)
//   ]
// }

const PermissionRecord = Record({
  edit: {
    account: false,
    resources: false,
    users: false
  },
  resources: {
    buildings: [],
    markerTypeCategories: []
  },
  groups: []
});

export default class InvitationNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      touched: false,
      permissions: new PermissionRecord(),
      redirect: null,
      emailChips: [],
      options: {
        facilities: [],
        buildings: [],
        markerTypeCategories: [],
        groups: []
      }
    };
    autoBind(this);
  }

  async componentDidMount() {
    const options = await feathers.service('api/permissions-options').find();
    this.setState({ options });
  }

  handleArrayChange({ name, value }) {
    const path = [...name.split('.')];
    const { permissions } = this.state;
    const array = permissions.getIn(path);
    if (value.toggle === true) {
      this.setState({
        touched: true,
        permissions: permissions.setIn(path, [...array, value.value])
      });
    } else {
      this.setState({
        touched: true,
        permissions: permissions.setIn(
          path,
          array.filter(_id => _id !== value.value)
        )
      });
    }
  }

  handleFacility(facility, allChecked) {
    const path = ['resources', 'buildings'];
    const { permissions } = this.state;
    const buildingIds = facility.buildings.map(building => building._id);
    const currentBuildings = permissions.getIn(path);
    if (!allChecked) {
      // Use Set() to dedupe potential dupilicates
      const newBuildingIds = Array.from(
        new Set([...currentBuildings, ...buildingIds])
      );
      this.setState({
        touched: true,
        permissions: permissions.setIn(path, newBuildingIds)
      });
    } else {
      this.setState({
        touched: true,
        permissions: permissions.setIn(
          path,
          currentBuildings.filter(_id => !buildingIds.includes(_id))
        )
      });
    }
  }

  toggleAll({ name, value }) {
    const path = [...name.split('.')];
    if (value.toggle === true) {
      this.setState({
        touched: true,
        permissions: this.state.permissions.setIn(path, value.value)
      });
    } else {
      this.setState({
        touched: true,
        permissions: this.state.permissions.setIn(path, [])
      });
    }
  }

  handleChange({ name, value }) {
    const path = [...name.split('.')];
    this.setState({
      touched: true,
      permissions: this.state.permissions.setIn(path, value)
    });
  }

  handleOnPaste(event) {
    const inputValue = event.clipboardData.getData('Text');
    const validatedEmails = this.getUniqueEmails(inputValue);
    this.setState({
      emailChips: [...this.state.emailChips, ...validatedEmails],
      touched: true
    });
  }

  handleAddChip(inputValue) {
    const validatedEmails = this.getUniqueEmails(inputValue);
    this.setState({
      emailChips: [...this.state.emailChips, ...validatedEmails],
      touched: true
    });
  }

  getUniqueEmails(inputValue) {
    const currentEmails = this.state.emailChips.map(chip => chip.email);
    const incomingEmails = inputValue.trim().split(/[\s ,]+/);
    return (
      incomingEmails
        // Filter out duplicates from incoming
        .filter((email, index) => incomingEmails.indexOf(email) === index)
        // Filter out duplicates from state
        .filter(email => (!currentEmails.includes(email) ? email : null))
        .map(email => ({ isValid: isEmail(email), email }))
    );
  }

  handleDeleteChip(newChip, index) {
    const updatedEmailChips = this.state.emailChips.filter(
      chip => chip.email !== newChip.email
    );
    this.setState({ emailChips: updatedEmailChips });
  }

  handleSubmit() {
    /*
    Check that all emails are valid before querying the database. This will prompt the user to make an action if any are not valid and save a database call.
    */
    const { emailChips, permissions } = this.state;
    if (!emailChips.length) {
      return noty.errors('Please add at least one email.');
    }
    this.setState({ fetching: true });
    const emails = emailChips.map(chip => chip.email);
    const allEmailsValid = emailChips
      .map(chip => chip.isValid)
      .every(isValid => isValid);
    if (allEmailsValid) {
      const query = { email: { $in: emails } };
      InvitationRecord.find({ query })
        .then(duplicateInvitations => {
          if (duplicateInvitations.total > 0) {
            const duplicatedEmails = duplicateInvitations.data
              .toList()
              .toJS()
              .map(invitation => invitation.email);
            const validatedChips = emailChips.map(chip => {
              if (duplicatedEmails.find(email => chip.email === email)) {
                chip.isValid = false;
              }
              return chip;
            });
            noty.errors(
              `There are duplicate invitations for this account, please remove the highlighted emails to continue.`
            );
            this.setState({ emailChips: validatedChips, fetching: false });
          } else {
            const newInvitations = emailChips.map(chip => {
              return new InvitationRecord({
                email: chip.email,
                permissions: permissions.toJS()
              });
            });
            Promise.all(newInvitations.map(invite => invite.create()))
              .then(() => {
                let successMessage;
                newInvitations.length > 1
                  ? (successMessage = `${
                      newInvitations.length
                    } invitations sent!`)
                  : (successMessage = 'Invitation sent!');
                noty.success(successMessage);
                this.setState({ fetching: false, redirect: '/account/users' });
              })
              .catch(err => {
                noty.errors(err);
                this.setState({ fetching: false });
              });
          }
        })
        .catch(err => {
          noty.errors(err);
          this.setState({ fetching: false });
        });
    } else {
      noty.errors('Please check that all emails are valid.');
      this.setState({ fetching: false });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const { permissions, options, fetching, touched, emailChips } = this.state;
    const { buildings, markerTypeCategories } = permissions.resources;
    const { groups } = permissions;

    return (
      <div id="InvitationNew" className="margin-bottom-30">
        <Panel
          onSaveClick={this.handleSubmit}
          saveTitle="Invite New User"
          fetching={fetching}
          touched={touched}
          touchedMessage="Are you sure that you want to leave? This user has unsaved changes."
          checkCanAdd="users"
        >
          <div style={{ padding: '0 16px' }}>
            <div className="row">
              <div className="col-xs-12">
                <ChipInput
                  fullWidth
                  fullWidthInput
                  chipContainerStyle={{
                    marginTop: 22,
                    display: 'flex',
                    flexWrap: 'wrap'
                  }}
                  name="email"
                  hintText="Allow separation of email addresses with commas, line breaks, tab, or paste an entire list"
                  // in order: tab, enter, spacebar, comma
                  newChipKeyCodes={[9, 13, 32, 188]}
                  floatingLabelFixed
                  floatingLabelText="Emails"
                  value={emailChips}
                  onBlur={event => this.handleAddChip(event.target.value)}
                  onPaste={this.handleOnPaste}
                  onRequestAdd={this.handleAddChip}
                  onRequestDelete={this.handleDeleteChip}
                  chipRenderer={({ value, handleRequestDelete }, key) => (
                    <Chip
                      key={key}
                      backgroundColor={value.isValid ? '' : '#FF0000'}
                      labelColor={value.isValid ? '' : '#FFF'}
                      deleteIconStyle={value.isValid ? {} : { fill: '#f9f9f9' }}
                      onRequestDelete={handleRequestDelete}
                      style={{ margin: 2 }}
                    >
                      {value.email}
                    </Chip>
                  )}
                />
              </div>
            </div>
            <EditPermissionsToggles
              permissions={permissions}
              onChange={this.handleChange}
              disabled={fetching}
            />
          </div>
          <div style={{ margin: '40px 0', padding: '0 16px' }}>
            <p>
              Choose which resources the user can view. This is different from
              the options above where you may limit whether the user has account
              and resource editing capabilities.
            </p>
          </div>
          <div className="row" style={{ padding: '0 16px' }}>
            <FacilityPermissionsToggles
              title="Facilities"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={buildings}
              options={options}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              toggleFacility={this.handleFacility}
              disabled={fetching}
            />
            <EntityPermissionsToggles
              title="Marker Type Categories"
              className="col-md-7 col-sm-12 margin-bottom-30"
              entityArray={markerTypeCategories}
              entityName="resources.markerTypeCategories"
              options={options.markerTypeCategories}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
          <div style={{ margin: '40px 0', padding: '0 16px' }}>
            <p>
              Assign optional groups to this user. Groups can be used to search
              for users.
            </p>
          </div>
          <div className="row" style={{ padding: '0 16px' }}>
            <EntityPermissionsToggles
              title="User Groups"
              className="col-md-5 col-sm-12 margin-bottom-30"
              entityArray={groups}
              entityName="groups"
              options={options.groups}
              onChange={this.handleArrayChange}
              toggleAll={this.toggleAll}
              disabled={fetching}
            />
          </div>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Account/InvitationNew/index.jsx